import r from "./sentenceCase.js";
const n = (e) => e ? e.split(" ").map((t) => r(t)).join(" ") : "";
export {
  n as default
};
